import { useState, createContext, useContext } from "react";


// The actual value you want to access
export const GlobalSurveysContext = createContext({
    gallerySurveys: null,
    setGallerySurveys: () => {},
    exampleSurveys: null,
    setExampleSurveys: () => {},
    gallerySurveysLoaded: null,
    setGallerySurveysLoaded: () => {},
    userSurveyHistory: null,
    setUserSurveyHistory: () => {},
    userSurveyHistoryLoaded: null,
    setUserSurveyHistoryLoaded: () => {}
});

export const GlobalSurveysProvider = ({ children }) => {
    const [gallerySurveys,setGallerySurveys] = useState([]);
    const [exampleSurveys,setExampleSurveys] = useState([]);
    const [gallerySurveysLoaded,setGallerySurveysLoaded] = useState([]);
    const [userSurveyHistory,setUserSurveyHistory] = useState([]);
    const [userSurveyHistoryLoaded,setUserSurveyHistoryLoaded] = useState(false);

    const value = { gallerySurveys,setGallerySurveys, exampleSurveys, setExampleSurveys,
        gallerySurveysLoaded,setGallerySurveysLoaded,
        userSurveyHistory,setUserSurveyHistory,userSurveyHistoryLoaded,setUserSurveyHistoryLoaded};

    return <GlobalSurveysContext.Provider value={value}>{children}</GlobalSurveysContext.Provider>;
}

export const useGlobalSurveysProvider = () => {
    return useContext(GlobalSurveysContext);
} 